import type { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { ViewsHttpService } from '../../services/views-http.service';
import { ViewSwimlaneActions } from './swimlanes.store';

@Injectable({ providedIn: 'root' })
export class SwimlaneEffects {
  public fetchOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewSwimlaneActions.fetch),
      switchMap(({ payload: { storeSwimlaneGroupId, dataSourceId, data, queryParams } }) =>
        this.viewsHttpService.fetchSwimlanes(dataSourceId, data, queryParams).pipe(
          map(response =>
            ViewSwimlaneActions.fetchSuccess({
              payload: {
                data: { ...response, id: storeSwimlaneGroupId },
                concat: (queryParams?.page ?? 0) > 1,
              },
            }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(ViewSwimlaneActions.fetchFailed({ payload: { error, id: storeSwimlaneGroupId } })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private viewsHttpService: ViewsHttpService,
  ) {}
}
